import {clearDigitalShoBroadcastChannelName, ClearDigitalShoOAuthEvent} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/publishing-clear-digital-sho-panel/publishing-clear-digital-sho-panel.types';

export const addClearDigitalShoOAuthBroadcastChannel = (onSuccess: VoidFunction, onError: VoidFunction): BroadcastChannel | undefined => {
  const broadcastChannel = new BroadcastChannel(clearDigitalShoBroadcastChannelName);
  broadcastChannel.addEventListener('message', (ev: MessageEvent<ClearDigitalShoOAuthEvent>) => {
    if (ev.data === ClearDigitalShoOAuthEvent.SUCCESS) {
      onSuccess();
    } else {
      onError();
    }
  });

  return broadcastChannel;
};

export const removeClearDigitalShoOAuthBroadcastChannel = (clearDigitalShoOAuthBroadcastChannel?: BroadcastChannel): void => {
  if (!clearDigitalShoOAuthBroadcastChannel) {
    return;
  }

  clearDigitalShoOAuthBroadcastChannel.close();
};

